/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2022-07-07 11:49:52
 * @LastEditors: K
 * @LastEditTime: 2022-09-02 11:22:52
 */
import { unwrapResult } from '@reduxjs/toolkit'
import { Button, Col, Form, Input, Modal, notification, Row } from 'antd'
import React, { ReactElement, useContext } from 'react'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../app/store'

import { ThemeContext } from '../../../theme/ThemeContext'
import { getPostponeSubmit } from './notificationCenterSlice'

export const PostponeModalodal = (props: {
  isModalVisible: boolean
  adviseState?: any
  id: any
  onOk: () => void
  onCancel: () => void
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  return (
    <Modal
      width={500}
      title={'一键延期'}
      visible={props.isModalVisible}
      onOk={() => {
        props.onOk()
        form.resetFields()
      }}
      onCancel={() => {
        props.onCancel()
        form.resetFields()
      }}
      footer={null}
    >
      <Form
        autoComplete='off'
        form={form}
        onFinish={(fs) => {
          dispatch(getPostponeSubmit({ days: fs?.days, id: props?.id }))
            .then(unwrapResult)
            .then((v: any) => {
              notification.success({
                message: v,
              })
              props.onOk()
              form.resetFields()
            })
        }}
      >
        <Row>
          <Col span={24}>
            <Form.Item
              label='从今天开始往后延期'
              name='days'
              rules={[
                {
                  required: true,
                },
                {
                  pattern: new RegExp(/^\d+$|^\d+[.]?\d+$/),
                  message: '请输入正确的延期天数',
                },
              ]}
            >
              <Input
                style={{ width: '150px', marginRight: '5px' }}
                addonAfter='天'
              />
            </Form.Item>
          </Col>

          <Row gutter={20} style={{ width: '100%', justifyContent: 'end' }}>
            <Button type='primary' htmlType='submit'>
              确定
            </Button>
          </Row>
        </Row>
      </Form>
    </Modal>
  )
}
